module.exports = __webpack_public_path__ + "static/img/mk.aa4bb76f.svg";